import React, { FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../redux/States';
import { ErrorDispatches } from '../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { downloadSheets, getGradeMinMax } from '../utils';
import { Button, Col, Row as BSRow, Modal } from 'react-bootstrap';
import {
  AuthedLayout,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
} from '../components';
import { ClassSetting, StudentName, GradeClass, UserInfo } from '../model';
import apis from '../apis';
import { useHistory } from 'react-router';
import XLSX from 'xlsx-js-style';
import { DateTime } from 'luxon';
import { I18N } from '../i18n-raw';
import { toast } from 'react-toastify';

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;
const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;
const exportStudent: FunctionComponent<Props> = ({
  user,
  loading,
  catchErrorForModal
}) => {
  if (loading) {
    useHistory().go(0);
    return <></>;
  }
  type Student = {
    seat?: number | null;
    name?: string | null;
    year?: number | null;
    sex?: string | null;
    cSex?: string | null;
    blood?: string | null;
    aborigine?: string | null;
    pid?: string | null;
    dad?: string | null;
    mom?: string | null;
    zip?: string | null;
    address?: string | null;
    erTel?: string | null;
    tel?: string | null;
    realAge?: string | null;
    birth?: DateTime | null;
    sid?: string | null;
    gradeNoSeat?: string | null;
    hospital?: string | null;
    [key: string]: any; // Index signature to allow dynamic keys 
  };
  const headerDisplayKeys: HeaderDisplayKeysWithType<GradeClass>[] = [
    {
      display: '年級',
      property: 'grade',
    },
    {
      display: '年級',
      property: 'grade',
      onRender: (v, i, e) => {
        return v ? I18N.Grades[v] : v;
      }
    },
    {
      display: '入學年',
      property: 'grade',
      onRender: (v, i, e, c) => {
        return year - (v - min)
      }
    },
    {
      display: '學生數',
      property: 'studentCount',
    },
    {
      display: '',
      property: 'grade',
      onRender: (v, i, e, c) => {
        return <>
          <Button
            onClick={() => { downloadExcel(v, year - (v - min)) }}
            disabled={c.allValues.studentCount <= 0}
          >
            匯出基本資料
          </Button>
        </>
      }
    },
  ];
  const schoolList: string[] = ['010301', '011501', '011607', '020301', '020302', '020308', '020403', '020404', '020405', '020407', '020409', '020C03', '020C04', '020C05', '020C07', '020C09', '020F012', '030305', '030403', '030C02', '030c03', '030C07', '030C08', '030G92', '040302', '040304', '040308', '040B02', '0413032', '041303', '041305', '041305', '0413062', '041306', '0413072', '041307', '041401', '041602', '041601', '041602', '041B03', '041B05', '041B06', '041B07', '041C01', '050303', '050310', '050314', '050315', '050401', '050404', '050407', '050B14', '050C07', '050f01', '0513022', '051302', '0513062', '051306', '051307', '051307', '051408', '051413', '051B02', '051B05', '051B06', '051C08', '051C11', '060322', '060323', '063C02', '060c07', '060C08', '060C20', '070301', '070304', '070307', '070316', '070319', '070401', '070402', '070403', '070405', '070406', '070408', '070409', '070410', '070415', '070B16', '070C01', '070C02', '070c03', '070C05', '070C06', '070C08', '070C09', '070c10', '070C15', '070F011', '070F012', '070F021', '070F021', '071311', '071311', '071317', '071318', '071414', '071B18', '071C14', '080302', '080305', '080307', '080308', '080401', '080403', '080404', '080406', '080410', '080B05', '080B07', '080B08', '080c04', '080C06', '080C10', '081311', '081312', '081312', '0813131', '081313', '081313', '0813142', '081314', '081409', '081C09', '090305', '090306', '090315', '090401', '090402', '090403', '090404', '090413', '090C42', '090C03', '090C13', '090F012', '090F012', '091307', '091307', '0913082', '091308', '091311', '091312', '091316', '091318', '091319', '0913202', '091410', '091414', '091B18', '091C10', '091C14', '100301', '100302', '100402', '100B01', '101304', '101406', '101C05', '101C07', '110302', '110308', '110311', '110312', '110314', '110315', '110317', '1103281', '110328', '110401', '110403', '110404', '110405', '110406', '110407', '110409', '110410', '110B02', '110B08', '110B12', '110C01', '110C03', '110C04', '110C05', '110C06', '110C09', '110F011', '110F01', '111313', '111313', '111320', '111321', '111321', '111322', '111322', '111323', '111326', '111419', '111427', '111502', '111B20', '111B25', '111B26', '111C16', '111C19', '111C27', '111G91', '120303', '120304', '120311', '120319', '120401', '120402', '120409', '120C02', '120C09', '121306', '1213072', '121307', '1213182', '121318', '1213202', '1213202', '121320', '121405', '121413', '121415', '121417', '121B06', '121C05', '121C10', '121C13', '121C15', '121C17', '130302', '130305', '130306', '130322', '130401', '130403', '130404', '130410', '130417', '130601', '130C03', '130C04', '130C17', '131307', '1313082', '131308', '131311', '131311', '131409', '131501', '131B07', '131C09', '131C18', '1402223', '1403012', '140301', '140302', '140303', '140404', '140405', '140408', '140601', '140C01', '140C05', '140C08', '1413072', '141307', '141406', '150302', '150303', '150309', '150401', '150404', '150405', '150411', '150601', '150B09', '150c04', '150C05', '150C11', '150F012', '150F012', '1513062', '151306', '151307', '151312', '151312', '151410', '151602', '151C10', '160302', '160401', '170301', '170302', '170403', '170404', '170B01', '170C03', '170C04', '170F011', '170F01', '1713062', '171306', '1713082', '171308', '171405', '171407', '171B08', '1803012', '1803012', '180301', '180302', '180309', '180403', '180404', '180601', '180C03', '180c04', '181305', '1813062', '181306', '1813072', '181307', '181308', '181601', '181B05', '181B07', '181B08', '190406', '190601', '190C06', '191603', '200302', '200303', '200401', '200405', '200406', '200407', '200601', '200B03', '200C05', '200c06', '200C07', '200F012', '200F012', '201304', '201304', '201310', '201310', '2013122', '201312', '2013132', '201313', '201314', '201408', '201B09', '201C08', '210303', '210305', '210306', '210309', '210408', '210416', '210601', '210B05', '210B09', '210C08', '210F011', '210F012', '211301', '211302', '211304', '2113102', '211310', '211314', '2113152', '211315', '211317', '211318', '211320', '211407', '211412', '211419', '211601', '211602', '211B01', '211B02', '211B14', '211B17', '211C07', '211C12', '211C19', '3303012', '330301', '330601', '380301', '380601', '4001443', '5403012', '540301', '580301', '6104052', '710301', '710401', '720301', '040F011', '040F01', '130F012', '130F01', '140F01', '020F01', '070F01', '070F024', '090F01', '091320', '150F01', '1513121', '200F01', '1913022', '191302', '210F01', '080F012', '080F01', '011399', '110F01', '710C01', '140F011', '140F012', '030B16', '061B17', '080C07', '101B05', '101B08', '101B09', '121B18', '121C08', '121C12', '121C16', '131C14', '151B07', '171C07', '180G91', '181B06', '181C08', '191B08', '201B04', '201B72', '211B13', '211B18', '321B01', '341B02', '361B01', '381B05', '411C01', '421B01', '581B01', '011307', '011607', '024325', '024699', '071318', '141301', '131601', '181502', '181603', '121502', '121502', '0513071', '0603232', '610405', '091319', '171601', '121302', '1913021', '040F011', '130F012', '080F012', '050f01', '0713183', '121405', '1313072', '211603', '100303', '130307', '061323', '111601', '060Q23', '120320', '1203202', '170F011'];
  const { year, sem } = user.semesters[user.currentSemester];
  const { min, max } = getGradeMinMax(user.currentRank);
  const [classSettings, setClassSettings] = useState<ClassSetting[]>([]);
  const [gradeClassSettings, setGradeClassSettings] = useState<GradeClass[]>([]);
  const tableHeader = [...headerDisplayKeys];
  const [userinfo, setUser] = useState<UserInfo>();
  const [waitingShow, setWaitingShow] = useState(false);
  const { currentSemester, semesters, currentSchool, schools } = user;
  const yearSem = semesters[currentSemester];
  const [fromTaoyuanCity, setFromTaoyuanCity] = useState(false);
  
  
  useEffect(() => {
    apis.getSchoolListInfo([currentSchool])
      .then((response) => {
        if (response.length > 0 && response[0].areaID.toString().startsWith('7')) {
          setFromTaoyuanCity(true);
        }
      })
      .catch((err) => {
        console.log(err);
        
      })
  }, []);

  useEffect(() => {
    apis.getClassSettings(year, sem)
      .then((data) => {
        setClassSettings(data);
        // 計算各年級總人數       
        const result: Record<number, number> = {};
        data.forEach(item => {
          const grade = item.grade;
          if (!result[grade]) {
            result[grade] = 0;
          }
          result[grade] += item.studentCount;
        });

        const summary = [];
        for (let grade = min; grade <= max; grade++) {
          summary.push({
            grade: grade,
            studentCount: result[grade] || 0,
            year: year - (grade - min)
          });
        }
        setGradeClassSettings(summary);
      })
      .catch();

    apis.getUserInfo()
      .then((u) => {
        setUser(u);
      })
      .catch(catchErrorForModal);      
  }, [user]);

  function downloadExcel(grade: number, studentYear: number) {
    const classes = classSettings.filter((item) => item.grade == grade);

    apis.getStudentNameList(
      classes,
      year,
      sem
    )
      .then((r) => {
        const studentData = r.map(value => ({ ...value, realAge: calculateAge(value.birth) }));
        generateExcel(studentData, classes, studentYear);
      })
      .catch()
  }
  function generateExcel(data: StudentName[], classes: ClassSetting[], studentYear: number) {
    const customColumns = [
      '身分證字號',
      '學號',
      '姓名',
      '性別',
      '入學年',
      '班級',
      '座號',
      '生日',
      '血型',
      '身分',
      '父親姓名',
      '母親姓名',
      '監護人',
      '郵遞區號',
      '電話',
      '住址',
      '緊急聯絡方式',
    ];
    const headArr = customColumns.filter(m => !!m);
    const allStudentRows: any[][] = [headArr];
    const studentData = data.map((student: Student) => {
      return [
        student.pid,
        student.sid,
        student.name,
        student.sex,
        student.year,
        student.classNo,
        student.seat,
        student.birth?.toFormat('yyyy/MM/dd'),
        student.blood,
        student.aborigine?.toString(),
        student.dad,
        student.mom,
        student.guardian,
        student.zip,
        student.tel,
        student.address,
        student.erTel
      ];
    });

    allStudentRows.push(...studentData);
    // 建立一個單一工作表
    const worksheet = XLSX.utils.aoa_to_sheet(allStudentRows);

    // 建立單一工作表的物件
    const sheet = {
      name: 'Data',
      sheet: worksheet
    };

    downloadSheets(`基本資料(${studentYear}年入學學生)`, userinfo?.exportFileType, sheet);
  }

  function calculateAge(birthDate: DateTime): number {
    const birthDateObj = new Date(
      birthDate.year,
      birthDate.month - 1,
      birthDate.day
    );

    const today = new Date();
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--;
    }

    return age;
  }

  function downloadInjuriesStudentExcel() {
    setWaitingShow(true);
    apis.getGraduatedStudentNameList(
      classSettings,
      yearSem.year,
      yearSem.sem
    )
    .then((r) => {
      const studentData = r.map(value => ({ ...value, realAge: calculateAge(value.birth) }));
      generateInjuriesStudentExcel(studentData);
      setWaitingShow(false);
      toast.success('學生資料下載完成');
    })
    .catch()
  }

  function generateInjuriesStudentExcel(data: StudentName[]) {
    const headArr = [
      '身分證字號',
      '學號',
      '姓名',
      '性別',
      '入學年(小一)',
      '班級',
      '座號',
      '生日',
      '血型',
      '身分',
      '父親姓名',
      '母親姓名',
      '監護人',
      '郵遞區號',
      '電話',
      '住址',
      '緊急聯絡方式'
    ];

    const studentData = data.map((student: Student) => {
      return [
        student.pid,
        student.sid,
        student.name,
        student.sex,
        student.year,
        student.classNo,
        student.seat,
        student.birth?.toFormat('yyyy/MM/dd') || '',
        student.blood || '',
        student.aborigine || '',
        student.dad,
        student.mom,
        student.guardian,
        student.zip,
        student.tel,
        student.address,
        student.erTel
      ];
    });

    const sheetData = [
      headArr,
      ...studentData
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    const schoolName = schools[currentSchool]?.name || currentSchool;

    downloadSheets(
      `${schoolName}新系統學生資料表`,
      0,
      {
        name: `學生資料表`,
        sheet: worksheet
      }
    );
  }

  return (
    <AuthedLayout>
      <BSRow className="mb-4">
        <Col sm={12}>
          <p className='text-danger font-weight-bold'>※請善盡保護學生資料之責任，若無正式公文或依據，請勿將資料轉交給其他單位。</p>
        </Col>
        匯出的資料, 可以更改後再匯入
      </BSRow>
      <BSRow>
        <EditableTableDiv
          headers={tableHeader}
          values={gradeClassSettings}
          onRowRender={(v) => ({ deleteable: v.studentCount === 0 })}
        />
      </BSRow>
      {!schoolList.includes(currentSchool) && fromTaoyuanCity ? 
      <>
        <BSRow className="mt-4">
          <Col sm={12} className="text-right">
            <Button className="btn btn-primary" onClick={downloadInjuriesStudentExcel}>
              全部資料匯出
            </Button>
          </Col>
        </BSRow>
        <Modal
          show={waitingShow}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              資料下載中
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>因資料量較大，下載需較長的時間，請您耐心等候，期間請勿操作系統或切換畫面，謝謝配合。</p>
          </Modal.Body>
        </Modal>
      </> : <></>}
    </AuthedLayout>
  );
};


export const ExportStudent = connector(exportStudent);
